<div (keydown.enter)="submit()" class="flex flex-col gap-4">
  <div class="flex gap-2">
    <div class="flex-1">
      <elcia-text-input [control]="accountingAccountForm.controls.name"
                        [label]="'accounting-account.name' | translate"/>
    </div>
    <div class="flex-1">
      <elcia-text-input [control]="accountingAccountForm.controls.account"
                        [label]="'accounting-account.account' | translate"/>
    </div>
    <div class="flex-1">
      <elcia-account-type-dropdown [control]="accountingAccountForm.controls.accountType" [isMulti]="false"/>
    </div>
  </div>
</div>
